import { Branding } from "../../../types/Branding";
import { UserConfig } from "../../../types/UserConfig";
import {initGTM} from "../../../analytics/util/analyticUtil";

export class IvConversionEventService {

    public static id = "ivConversionEventService";

    /** @ngInject */
    public constructor(private userConfig: UserConfig) {
    }

    public sendConversionEvent() {
        if (this.userConfig.branding === Branding.IV) {
            initGTM("GTM-MCZR77F");
        }
    }

}
